import DataSubjectAccessRequestNoteService from '../services/dsar-note-service';

export const dataSubjectAccessRequestNote = {
  namespaced: true,
  state: {
    notes: null,
    note: null,
  },
  actions: {
    initNote({ commit }, note) {
      commit('setNote', note);
    },
    notesList({ commit }, dsarId) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestNoteService.notesList(dsarId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setNotes', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    createNote({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestNoteService.create(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getNote({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setNote', null);
      return DataSubjectAccessRequestNoteService.get(
        payload.dsarId,
        payload.dsarInternalNoteId,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setNote', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    updateNote({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestNoteService.update(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    deleteNote({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestNoteService.delete(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setNotes(state, newNotes) {
      state.notes = newNotes;
    },
    setNote(state, newNote) {
      state.note = newNote;
    },
  },
};
